"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Camera = void 0;
const react_1 = __importDefault(require("react"));
const react_webcam_1 = __importDefault(require("react-webcam"));
const styles_1 = require("./styles");
const Camera = ({ webcamRef, canvasRef, handleVideoPlay, facingMode = 'user', }) => {
    const videoConstraints = {
        width: 640,
        height: 480,
        facingMode: facingMode,
    };
    return (react_1.default.createElement(styles_1.WebcamContainer, { width: videoConstraints.width, height: videoConstraints.height },
        react_1.default.createElement(react_webcam_1.default, { audio: false, ref: webcamRef, onLoadedData: handleVideoPlay, screenshotFormat: "image/jpeg", forceScreenshotSourceSize: true, videoConstraints: videoConstraints }),
        react_1.default.createElement("canvas", { ref: canvasRef })));
};
exports.Camera = Camera;
//# sourceMappingURL=index.js.map